/* terminal/actions */
import { action } from "typesafe-actions";
import { TokenWallet, TokenWalletActionTypes } from "./types";
export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(TokenWalletActionTypes.FETCH, { id, params, callback });
export const fetchSuccess = (closeloop: TokenWallet) =>
  action(TokenWalletActionTypes.FETCH_SUCCESS, closeloop);
export const fetchError = (error: string) =>
  action(TokenWalletActionTypes.FETCH_ERROR, error);